import React from "react";
import connect from "../i18n/connect";
import { getStocksListSource } from "../redux/modules/tags/selector";
import { updateStocksListSource } from "../redux/modules/tags";

export default function withStocksListNavigationHeader(WrappedComponent) {
  const mapStateToProps = state => ({
    stocksListSource: getStocksListSource(state)
  });

  const mapDispatchToProps = {
    updateStocksListSource
  };

  @connect(mapStateToProps, mapDispatchToProps)
  class WithStocksListNavigationHeader extends React.Component {
    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return WithStocksListNavigationHeader;
}
